import { useState, useEffect, useRef } from 'react';

const TESTIMONIALS = [
  { name: 'Sofia M.', text: 'Best nail experience I\'ve ever had. The detail work is absolutely unreal — every nail looked like a piece of art.', rating: 5 },
  { name: 'Camille R.', text: 'Daniela brings every idea to life. I showed her a vague Pinterest board and she created something even better than I imagined.', rating: 5 },
  { name: 'Priya K.', text: 'The precision is unlike anything I\'ve seen. Clean, flawless, and they lasted four full weeks without a chip.', rating: 5 },
  { name: 'Leila T.', text: 'I\'ve been to many nail studios. This is the only one I keep coming back to. The consultation alone sets it apart.', rating: 5 },
  { name: 'Mara J.', text: 'Truly a luxury experience from start to finish. The studio is immaculate and the results speak for themselves.', rating: 5 },
];

export default function TestimonialsSection() {
  const [active, setActive] = useState(0);
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.2 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const t = setInterval(() => setActive((p) => (p + 1) % TESTIMONIALS.length), 5000);
    return () => clearInterval(t);
  }, []);

  return (
    <section ref={ref} className="bg-white py-24 md:py-32 px-6">
      <div className="max-w-4xl mx-auto text-center">
        <span className="font-sans text-xs tracking-widest2 uppercase text-gold block mb-4">Client Stories</span>
        <h2 className={`font-serif text-4xl md:text-5xl text-ink font-light mb-16 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          What They Say
        </h2>

        <div className={`relative transition-all duration-700 delay-200 ${visible ? 'opacity-100' : 'opacity-0'}`}>
          {/* Large quote mark */}
          <span className="font-serif text-9xl text-blush-mid leading-none absolute -top-6 left-1/2 -translate-x-1/2 select-none pointer-events-none" aria-hidden>&#8220;</span>

          <div className="relative min-h-[160px] flex items-center justify-center">
            {TESTIMONIALS.map((t, i) => (
              <div
                key={i}
                className={`absolute inset-0 flex flex-col items-center justify-center transition-all duration-700 ${i === active ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}
              >
                <p className="font-serif text-xl md:text-2xl text-ink font-light italic leading-relaxed max-w-2xl mx-auto px-4">
                  &ldquo;{t.text}&rdquo;
                </p>
              </div>
            ))}
          </div>

          <div className="mt-10 flex flex-col items-center gap-3">
            <div className="flex gap-1">
              {Array.from({ length: 5 }).map((_, i) => (
                <i key={i} className="ri-star-fill text-gold text-sm"></i>
              ))}
            </div>
            <span className="font-sans text-sm tracking-wider text-ink-muted">{TESTIMONIALS[active].name}</span>
            <span className="font-sans text-xs tracking-widest uppercase text-gold-light">Verified Client</span>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-8">
            {TESTIMONIALS.map((_, i) => (
              <button
                key={i}
                onClick={() => setActive(i)}
                className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${i === active ? 'bg-gold w-6' : 'bg-blush-deep'}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
